import actionTypes from "../actions/action-types";
// import {combineReducers} from 'redux';
import {set, get} from '../utils/dotutils';
import isEqual from "lodash-es/isEqual";
import React from "react";

export const createEditorReducer = (editor, initialState) => {
    const pristineInitialState = {
        initialValues: initialState,
        pristineValues: initialState,
        values: initialState,
        dirty: false,
        formId: new Date().getTime()
    }
    return (state = pristineInitialState, action) => {
        const newState = JSON.parse(JSON.stringify(state));
        switch (action.type) {
            case actionTypes.SET_EDITOR_CONFIG:
                if (action.editor + "" === "" + editor) {
                    newState.componentConfig = action.componentConfig;
                    if (action.newFormId) {
                        newState.formId = new Date().getTime();
                    }
                    return newState;
                } else {
                    return newState;
                }
            case actionTypes.SET_INITIAL_VALUES:
                if (action.editor + "" === "" + editor) {
                    pristineInitialState.initialValues = action.payload;
                    newState.initialValues = action.payload;
                    newState.dirty = !isEqual(newState.values, newState.initialValues);
                    if (action.newFormId) {
                        newState.formId = new Date().getTime();
                    }
                    return newState;
                } else {
                    return newState;
                }
            case actionTypes.SET_PRISTINE_VALUES:
                if (action.editor + "" === "" + editor) {
                    pristineInitialState.pristineValues = action.payload;
                    newState.pristineValues = action.payload;
                    newState.dirty = !isEqual(newState.values, newState.initialValues);
                    if (action.newFormId) {
                        newState.formId = new Date().getTime();
                    }
                    return newState;
                } else {
                    return newState;
                }
            case actionTypes.SET_FORM_VALUES:
                if (action.editor + "" === "" + editor) {
                    newState.initialValues = JSON.parse(JSON.stringify(action.payload));
                    newState.values = action.payload;
                    newState.dirty = !isEqual(newState.values, newState.initialValues);
                    if (action.newFormId) {
                        newState.formId = new Date().getTime();
                    }
                    return newState;
                } else {
                    return newState;
                }
            case actionTypes.SET_FIELD_VALUE:
                if (action.editor + "" === "" + editor) {
                    if (action.field) {
                        set(newState.values, action.field, action.value);
                    } else {
                        newState.values = {...action.value};
                    }
                    newState.dirty = !isEqual(newState.values, newState.initialValues);
                    if (action.newFormId) {
                        newState.formId = new Date().getTime();
                    }
                }
                return newState;
            default:
                return newState;
        }
    };
}

const DiscountConditionEditorReducer = createEditorReducer("DiscountCondition", {
    connection_type: "discountcondition",
    filter: null,
});
const DiscountTargetEditorReducer = createEditorReducer("DiscountTarget", {
    connection_type: "discounttarget",
    filter: null,
});
const DiscountExclusionEditorReducer = createEditorReducer("DiscountExclusion", {
    connection_type: "discountexclusion",
    filter: null,
});

const reducers = {
    DiscountCondition:                      DiscountConditionEditorReducer,
    DiscountTarget:                         DiscountTargetEditorReducer,
    DiscountExclusion:                      DiscountExclusionEditorReducer,
};

export const REDUX_EDITOR_INIT = "@@redux/INIT.TADAM";

Object.keys(reducers).forEach(function (key) {
    reducers[key](undefined, {
        type: REDUX_EDITOR_INIT
    });
});

function getUndefinedStateErrorMessage(key, action) {
    let actionType = action && action.type;
    let actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
    return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

const editorsReducer = (state, action) => {
    if (state === void 0) {
        state = {};
    }

    let hasChanged = false;
    const nextState = {};

    if (action.type.indexOf("@@redux/INIT") === 0) {
        Object.keys(state).map((editor) => {
            if (!reducers[editor]) {
                reducers[editor] = createEditorReducer(editor, state[editor]);
            }
        })
    }

    Object.keys(reducers).map((_key) => {
        const reducer = reducers[_key];
        const previousStateForKey = state[_key];
        const nextStateForKey = reducer(previousStateForKey, action);

        if (typeof nextStateForKey === 'undefined') {
            const errorMessage = getUndefinedStateErrorMessage(_key, action);
            throw new Error(errorMessage);
        }

        nextState[_key] = nextStateForKey;
        hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    });

    return hasChanged ? nextState : state;
};

export const addEditor = (editor, reducer) => {
    if (reducers[editor]) {
        throw {message: "'" + editor + "' editor reducer is exists!"};
    }
    reducer(undefined, {type: REDUX_EDITOR_INIT});
    reducers[editor] = reducer;
}

export const replaceEditor = (editor, reducer) => {
    reducer(undefined, {type: REDUX_EDITOR_INIT});
    reducers[editor] = reducer;
}

export const removeEditor = (editor) => {
    delete reducers[editor];
}

export default editorsReducer;